const navForm = document.querySelector(".ruin__navform");

if (navForm) {
  const list = navForm.closest(".ruins__gallery").querySelector(".ruin__list");
  const items = Array.from(
    navForm.closest(".ruins__gallery").querySelectorAll(".ruin__item")
  );
  let filteredArray = [];
  navForm.addEventListener("change", (e) => {
    console.log(e.target.value);
    if (e.target.value === "all") {
      showFilteredGallery(items);
      return;
    }
    filteredArray = items.filter((i) => i.dataset.place === e.target.value);
    showFilteredGallery(filteredArray);
  });

  function showFilteredGallery(array) {
    if (array.length === 0) return;
    list.textContent = "";

    array.forEach((el) => {
      list.appendChild(el);
    });
  }
}
